<template>
  <v-btn
    :color="'#FFF777'"
    class="ct-text-bolder d-flex justify-center align-stretch black--text"
    title="返回列表"
    @click="backList()"
  >
    <span style="display:inline-block">返回列表</span>
  </v-btn>
</template>
<script>
export default {
  methods: {
    backList() {
      let str = "";
      if (typeof this.$route.name !== "undefined") {
        str = this.$route.name.split("-").shift();
        const itemName = "Page" + "." + str + ".Back";
        sessionStorage.setItem(itemName, true);
      }

      this.$router.push({
        name: str
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
